const baseUrl = String(
  import.meta.env.VITE_MARKET_REPORT_API_URL ?? "",
).replace(/\/+$/, "");

const apiKey = String(import.meta.env.VITE_MARKET_REPORT_API_KEY ?? "");

export function isMarketReportApiConfigured(): boolean {
  return Boolean(baseUrl && apiKey);
}

export function getMarketReportApiBaseUrl(): string {
  return baseUrl;
}

function buildUrl(endpoint: string): string {
  if (!baseUrl) {
    throw new Error(
      "VITE_MARKET_REPORT_API_URL is not set. Add it to your .env file.",
    );
  }
  const path = endpoint.startsWith("/") ? endpoint.slice(1) : endpoint;
  return `${baseUrl}/${path}`;
}

export function marketReportApiHeaders(
  includeJsonContentType = true,
): Record<string, string> {
  const headers: Record<string, string> = {
    "X-Api-Key": apiKey,
  };
  if (includeJsonContentType) {
    headers["Content-Type"] = "application/json";
  }
  return headers;
}

export function marketReportApiGetUrl(endpoint: string): string {
  return buildUrl(endpoint);
}

export function marketReportApiPostUrl(endpoint: string): string {
  return buildUrl(endpoint);
}
